module.exports = __webpack_public_path__ + "images/embed/delete.gif";